import { render } from "./home5.vue?vue&type=template&id=56bc2baa"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__